import { Trans, useTranslation } from "react-i18next"
import { I18_DEFAULT_NAME_SPACE } from "./constants"
import { TranslateMethods, getTranslateMethods } from "./utils"

// We can handle updating the translate namespace later
export const useTranslate = () => {
  const { t, i18n, ready } = useTranslation(I18_DEFAULT_NAME_SPACE, {
    useSuspense: false
  })
  const translateMethods: TranslateMethods = getTranslateMethods(t)

  return {
    ...translateMethods,
    i18n,
    Trans,
    ready
  }
}

export default useTranslate
